export var OnBoardingStatus;
(function (OnBoardingStatus) {
    // 未开始，例如暂未查找到步骤的节点
    OnBoardingStatus[OnBoardingStatus["NOT_READY"] = 0] = "NOT_READY";
    // 已经准备好
    OnBoardingStatus[OnBoardingStatus["READY"] = 1] = "READY";
    // 流程结束
    OnBoardingStatus[OnBoardingStatus["END"] = 2] = "END";
})(OnBoardingStatus || (OnBoardingStatus = {}));
